/* eslint-disable import/no-cycle */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next';
import { useMedia } from 'react-media';
import { Button, Icon, Popup } from 'semantic-ui-react';

import { useMenuEntries } from '../../../../config/config.context';
import { bem } from '../../../../core/design/bem';
import { GLOBAL_MEDIA_QUERIES } from '../../../../utils/mediaQueries';
import ImageIcon from '../../../ImageIcon';
import { PageItem } from '../../AppSecondaryMenu';
import { MessagesList } from './MessagesList';
import './MessagesPopup.scss';

const css = bem('MessagesPopup');

const translationPrefix = 'messages.popup';

type MessagesPopupProps = {
  icon?: Record<string, any>;
  path?: string;
  maxItems?: number;
  showAll?: boolean;
} & typeof MessagesPopupDefaultProps;

const MessagesPopupDefaultProps = {
  icon: undefined,
  maxItems: 10,
  path: '/messages',
  showAll: false,
};

const MessagesPopup = (props: MessagesPopupProps): JSX.Element => {
  const { t } = useTranslation();
  const { icon } = props;
  const messages: Record<string, any>[] = [];
  const { entries, config } = useMenuEntries();
  const entry = entries?.find((e) => e.type === 'messages');
  const { mobile } = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  if (mobile) {
    return (
      <PageItem
        className="item--MessagesPopup"
        entry={entry}
        count={messages.length}
        config={config}
      />
    );
  }
  return (
    <Popup
      on="click"
      pinned
      position="bottom center"
      className={css()}
      wide
      size="small"
      trigger={
        <Button icon className={css('button').toString()}>
          {icon ? (
            <ImageIcon
              className={css('icon')}
              icon={icon}
              {...(icon as any)}
              style={{ display: 'initial' }}
            />
          ) : (
            <Icon className={css('icon')} name="bell" size="large" />
          )}
          <span className={css('counter')}>{messages.length}</span>
        </Button>
      }
    >
      <Popup.Header className={css('header').toString()}>
        {t(`${translationPrefix}.header`)}
      </Popup.Header>
      <Popup.Content>
        <MessagesList messages={messages} />
      </Popup.Content>
    </Popup>
  );
};

MessagesPopup.defaultProps = MessagesPopupDefaultProps;

export default MessagesPopup;
